import { useQuery } from "@tanstack/react-query";
import { queryClient } from "shared/api/queryClient";
import { getFaqGroups } from "../api/getFaqGroups";
import { FaqGroup, FaqGroupDataToUpdate } from "../types";

const getQueryKey = (): any => {
  return ["faqGroups"];
};

export const useFaqGroupsQuery = () => {
  return useQuery({
    queryKey: getQueryKey(),
    queryFn: () => getFaqGroups(),
    staleTime: 0,
  });
};

export const invalidateFaqGroupsQuery = () => {
  return queryClient.invalidateQueries({
    queryKey: getQueryKey(),
  });
};

export const setFaqGroupsQueryData = (data: FaqGroupDataToUpdate[]) => {
  queryClient.setQueryData(getQueryKey(), data);
};

export const getFaqGroupsQueryData = () => {
  return queryClient.getQueryData<FaqGroup[]>(getQueryKey());
};
